import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=520ce2dd&"
import script from "./DropdownButton.vue?vue&type=script&lang=ts&"
export * from "./DropdownButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports